module.exports = __webpack_public_path__ + "img/407.8fc63bd1.jpg";